import React from 'react';
import PropTypes from 'prop-types';

import useProductFavoriteV2 from 'data-hooks/useProductFavoriteV2';
import PDPFavoriteButtonUI from './PDPFavoriteButtonUI';

const PDPFavoriteButton = ({ size = 'md', className }) => {
  const { isFavorited, onFavClick } = useProductFavoriteV2();
  return (
    <PDPFavoriteButtonUI
      isFavorited={isFavorited}
      onFavClick={onFavClick}
      size={size}
      className={className}
    />
  );
};

PDPFavoriteButton.propTypes = {
  size: PropTypes.oneOf(['xs', 'sm', 'md']),
  className: PropTypes.string,
};

export default PDPFavoriteButton;
